/* eslint-disable */
import React, {useState} from 'react';
import Tab from '../../component/Inc/Tab';
import 'contents/assets/scss/page/teacher.scss';
function MonthlySchedule() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '1주', value: 0},
    {title: '2주', value: 1},
    {title: '3주', value: 2},
    {title: '4주', value: 3},
    {title: '5주', value: 4}
  ];
  const hours = Array.from({length: 24}, (_, i) => {
    const hour = i < 10 ? `0${i}` : i;
    return `${hour}:00`;
  });
  return (
    <>
      <section className="component_monthly_schedule">
        <div className="com_calendar_wrap">
          <div className="check">
            <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
            <label htmlFor="rdo01">전체보기</label>
            <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
            <label htmlFor="rdo02">출석만 보기</label>
            <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
            <label htmlFor="rdo03">수업 예정 보기</label>
          </div>
          <div className="control">
            <div className="year_month_wrap">
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">03</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
            </div>
            <div className="week">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
          </div>
          <div className="com_count_wrapper">
            <div className="operators">
              <div className="operators_label">
                <span className="operators_count">진행 타임수</span>
                <span className="operators_value">98</span>
              </div>
            </div>
          </div>
        </div>
        <section className="weekly_calendar">
          <ul className="week_header">
            <li className="title">시간</li>
            <li className="date">월 (12)</li>
            <li className="date">화 (13)</li>
            <li className="date">수 (14)</li>
            <li className="date">목 (15)</li>
            <li className="date">금 (16)</li>
            <li className="date saturday">토(17)</li>
            <li className="date holiday">일(18)</li>
          </ul>
          <div className="week_schedule">
            <div className="time_schedule_grid">
              <ul className="time_cell">
                {hours.map((hour) => (
                  <li key={hour} className="time">
                    {hour}
                  </li>
                ))}
              </ul>
              <ul className="schedule_cell">
                {hours.map((hour, index) => {
                  const rowClassName = index % 4 === 2 || index % 4 === 3 ? 'time bg' : 'time';
                  return (
                    <li key={hour} className={rowClassName}>
                      {index === 7 && (
                        <div className="schedule_box gray" style={{top: '210px', height: '89px'}}>
                          <p className="title">김학생 103(고3ㆍ원격)</p>
                          <p className="phone">010-5647-3242</p>
                          <p className="des">&lt;수업 완료&gt;</p>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
              <ul className="schedule_cell">
                {hours.map((hour, index) => {
                  const rowClassName = index % 4 === 2 || index % 4 === 3 ? 'time bg' : 'time';
                  return (
                    <li key={hour} className={rowClassName}>
                      {index === 5 && (
                        <div className="schedule_box blue" style={{top: '150px', height: '59px'}}>
                          <p className="title">김학생 103(고3ㆍ원격)</p>
                          <p className="phone">010-5647-3242</p>
                          <p className="des">&lt;수업 완료&gt;</p>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
              <ul className="schedule_cell">
                {hours.map((hour, index) => {
                  const rowClassName = index % 4 === 2 || index % 4 === 3 ? 'time bg' : 'time';
                  return (
                    <li key={hour} className={rowClassName}>
                      {index === 8 && (
                        <div className="schedule_box blue" style={{top: '240px', height: '89px'}}>
                          <p className="title">김학생 103(고3ㆍ원격)</p>
                          <p className="phone">010-5647-3242</p>
                          <p className="des">&lt;수업 완료&gt;</p>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
              <ul className="schedule_cell">
                {hours.map((hour, index) => {
                  const rowClassName = index % 4 === 2 || index % 4 === 3 ? 'time bg' : 'time';
                  return <li key={hour} className={rowClassName}></li>;
                })}
              </ul>
              <ul className="schedule_cell">
                {hours.map((hour, index) => {
                  const rowClassName = index % 4 === 2 || index % 4 === 3 ? 'time bg' : 'time';
                  return (
                    <li key={hour} className={rowClassName}>
                      {index === 4 && (
                        <div className="schedule_box red" style={{top: '240px', height: '59px'}}>
                          <p className="title">김학생 103(고3ㆍ원격)</p>
                          <p className="phone">010-5647-3242</p>
                          <p className="des">&lt;수업 완료&gt;</p>
                        </div>
                      )}
                      {index === 17 && (
                        <div className="schedule_box red" style={{top: '510px', height: '89px'}}>
                          <p className="title">김학생 103(고3ㆍ원격)</p>
                          <p className="phone">010-5647-3242</p>
                          <p className="des">&lt;수업 완료&gt;</p>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
              <ul className="schedule_cell">
                {hours.map((hour, index) => {
                  const rowClassName = index % 4 === 2 || index % 4 === 3 ? 'time bg' : 'time';
                  return <li key={hour} className={rowClassName}></li>;
                })}
              </ul>
              <ul className="schedule_cell">
                {hours.map((hour, index) => {
                  const rowClassName = index % 4 === 2 || index % 4 === 3 ? 'time bg' : 'time';
                  return <li key={hour} className={rowClassName}></li>;
                })}
              </ul>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}

export default MonthlySchedule;
